export default __webpack_public_path__ + "static/media/price-3.10583800.png";